<template>
    <div id="partner_modal" class="ui middle aligned center aligned grid" v-if="showModal">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header"> {{ isEditMode ? "업체 정보 수정" : "업체 등록"}}</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">업체명</label>
                            <input type="text" name="name" placeholder="업체 이름을 입력하세요" v-model="name" autocomplete=off>
                            <p class="ui pointing blow orange basic label" v-if="$validator.hasError('name')">{{ $validator.getError('name') }}</p>
                        </div>
                        <div class="field" v-if="isEditMode">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="isTerminated">
                                <label>계약종료</label>
                            </div>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">아이디</label>
                            <input type="text" name="id" placeholder="아이디를 입력하세요" v-model="id" autocomplete=off>
                            <p class="ui pointing blow orange basic label" v-if="$validator.hasError('id')">{{ $validator.getError('id') }}</p>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">비밀번호</label>
                            <input type="text" name="password" v-model="password" autocomplete=off disabled>
                        </div>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">전화번호</label>
                        <input type="text" name="description" placeholder="031-1234-5678" v-model="phone" autocomplete=off>
                    </div>
                    <div class="field">
                        <label class="ui left aligned header">설명</label>
                        <input type="text" name="description" placeholder="메일주소, 담당자, 그외 부가 정보.." v-model="description" autocomplete=off>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div v-if="!isEditMode && $validator.isAllValidate()" class="ui positive left labeled icon button" @click="onAddClick">
                    <i class="checkmark icon"></i>등록
                </div>
                <div v-if="isEditMode && checkChanged()" class="ui orange left labeled icon button" @click="onEditClick">
                    <i class="checkmark icon"></i>저장
                </div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            showModal: 0,
            isEditMode: 0,
            name: 0,
            id: 0,
            password: 0,
            phone: 0,
            description: 0,
            oldPartner: 0,
            isTerminated : 0,
            onDone: 0,
        }
    },
    created: function() {
        this.showModal = this.isEditMode = false;
        this.id = this.name = this.phone = this.description = 0;
        this.password = "0000";
        this.isTerminated = false;
        this.oldPartner = null;
        this.changed = false;
    },
    mounted: function() {
        this.$event.set("openPartnerModal", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("openPartnerModal");
    },
    methods: {
        checkValidate() {
            this.$validator.clear();
            this.$validator.checkEmpty("id", this.id);
            this.$validator.checkEmpty("password", this.password);
            this.$validator.checkEmpty("name", this.name);
            return this.$validator.isAllValidate();
        },
        checkChanged() {
            if (this.oldPartner.id !== this.id) return true;
            if (this.oldPartner.name !== this.name) return true;
            if (this.oldPartner.phone !== this.phone) return true;
            if (this.oldPartner.description !== this.description) return true;
            if (this.oldPartner.isTerminated !== this.isTerminated) return true;
            return false;
        },
        open(partner, onDone)
        {
            this.showModal = true;
            this.isEditMode = (partner != null) ? true : false;
            this.id = (partner != null) ? partner.id : "";
            this.name = (partner != null) ? partner.name : "";
            this.phone = (partner != null) ? partner.phone : "";
            this.description = (partner != null) ? partner.description : "";
            this.isTerminated = (partner != null) ? partner.isTerminated || false : false;
            this.oldPartner = partner;
            this.onDone = onDone;
            this.checkValidate();
        },
        close() {
            this.showModal = false;
        },
        newPartner()
        {
            return {
                id: this.id,
                name: this.name,
                id: this.id,
                password: this.password,
                phone: this.phone,
                description: this.description,
                isTerminated: this.isTerminated,
            };
        },
        onAddClick() {
            this.close();
            this.$api.addPartner(this.newPartner(), this.onResponse);
        },
        onEditClick() {
            this.close();
            this.$api.editPartner(this.oldPartner._id, this.newPartner(), this.onResponse);
        },
        onResponse(resData) {
            if (resData.error) {
                alert(resData.error.message);
            } else {
                this.$store.commit("setPartners", resData.partners);
                if (this.onDone) this.onDone();
            }
        },
    },
    computed: {
        user() { return this.$store.getters.user; }
    },
    watch: {
        id: function(val) { this.id = this.$validator.replaceAlphaKorNum(val).substring(0, 12).toLowerCase(); this.checkValidate(); },
        password: function(val) { this.password = this.$validator.replaceAlphaNum(val).substring(0, 12).toLowerCase(); this.checkValidate(); },
        name: function(val) { this.name = this.$validator.replaceAlphaKorNumBracket(val).substring(0, 10); this.checkValidate(); },
        description: function(val) { if (val) this.description = val.substring(0, 30); },
        phone: function(val) { this.phone = this.$validator.replaceNumDashBracket(val).substring(0, 15); }
    },
}
</script>

<style>

#partner_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#partner_modal .column {
    max-width: 600px;
}

#partner_modal #header {
    padding: 20px 30px;
}

#partner_modal #body {
    padding: 0;
}

#partner_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#partner_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/PartnerModal.vue